<div *ngIf="isFullscreen()">
  <router-outlet></router-outlet>
</div>
<mat-sidenav-container class="sidenav-container" *ngIf="!isFullscreen()">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
               [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
               [mode]="(isHandset$ | async) ? 'over' : 'side'"
               [hidden]="isHandset$ | async"
               [opened]="false">
    <app-navigation></app-navigation>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Ball Score {{environmentAlias != 'prod' ? environmentAlias?.toUpperCase() : ""}}</span>
      <app-navigation horizontal="true" [hidden]="isHandset$ | async"></app-navigation>
      <span class="example-spacer"></span>
      <div *ngIf="auth.user$ | async as user; else login">
        <button mat-button class="more-button" [matMenuTriggerFor]="menu" aria-label="Toggle menu">
          <img class="avatar" src="{{user.photoURL}}" alt aria-label="Profile" />
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button mat-menu-item >
            Signed in as
            <strong>{{user.displayName}}</strong>
          </button>
          <hr />
          <mat-divider></mat-divider>
<!--
          <button mat-menu-item routerLink="/dashboard">Dashboard</button>
-->
          <button *ngIf="user.role === 'admin'" mat-menu-item routerLink="/admin">Admin overview</button>
          <!--<button mat-menu-item routerLink="/user-output-url">
            User output URLs
          </button>-->
          <button mat-menu-item [cdkCopyToClipboard]="getUserOutputUrl()">
            <mat-icon>content_copy</mat-icon>Copy user output URL
          </button>
          <button mat-menu-item aria-label="Sign out" (click)="auth.signOut()">
            Sign out
            <mat-icon>logout</mat-icon>
          </button>
        </mat-menu>
      </div>
      <ng-template #login>
        <button mat-stroked-button (click)="auth.googleSignin()">
          Sign in
          <mat-icon>login</mat-icon>
        </button>
      </ng-template>
    </mat-toolbar>
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
    <div class="release">{{release}}</div>
  </mat-sidenav-content>
</mat-sidenav-container>
